import { render } from "./CreditsPage.vue?vue&type=template&id=65f12fc6"
import script from "./CreditsPage.vue?vue&type=script&lang=js"
export * from "./CreditsPage.vue?vue&type=script&lang=js"
script.render = render

export default script